/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
import {
  Grid,
  Typography,
  Card,
  ButtonBase,
  Badge,
  Dialog,
  DialogTitle,
  Box,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux'
import DOMPurify from 'dompurify'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import InfoIcon from '@material-ui/icons/Info'
import myAlertsStyles from '../../../../../helpers/Alerts/AlertStyles'
import { acknowledgeAlert } from '../MyAlertsSlice'
import { logDashboardEvent } from '../../../events'
import {
  DOMPurifyAttributeOptions,
  DOMPurifyTagOptions,
} from '../../../../../helpers/Alerts/Alert'

export const MyNotificaionAlertList = ({
  alertList,
  classes,
  dialogHandler,
}) => {
  console.log('notification alert list ', alertList)
  return (
    <>
      <Grid container component="div" direction="column">
        {alertList?.length > 0 ? (
          alertList?.map((alert) => (
            <Grid item key={`${alert.id}`} className={classes.fullWidth}>
              <MyNoficationAlert
                alert={alert}
                classes={classes}
                dialogHandler={dialogHandler}
              />
            </Grid>
          ))
        ) : (
          <Grid
            container
            className={classes.fullWidth}
            direction="column"
            alignItems="center"
            style={{ marginTop: '10%' }}
          >
            <Grid item>
              <DoneAllIcon className={classes.doneIcon} />
            </Grid>
            <Grid item>
              <Typography align="center" variant="h5">
                You&apos;re all caught up!
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  )
}

const MyNoficationAlert = ({ alert, dialogHandler }) => {
  console.log('dialogHandler ', dialogHandler)
  const classes = myAlertsStyles()
  const longOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const firstDate = alert?.startDate?.split('T')[0]
  const [year, month, day] = firstDate.split('-')
  const date = new Date(year, month - 1, day)
  const [open, setOpen] = React.useState(false)
  console.log('open ', open)
  console.log('classes ', classes)
  return (
    <Card variant="outlined" className={classes.cardSpacing}>
      <ButtonBase
        focusRipple
        onClick={() => setOpen(true)}
        className={classes.buttonbase}
      >
        <Grid
          container
          direction="row"
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          wrap="nowrap"
          className={classes.verticalGrid}
        >
          <Grid item className={classes.iconHolder}>
            <Grid container direction="column" alignItems="center">
              <InfoIcon
                className={
                  classes[`icon${alert.severityCode}Alert`] ??
                  classes[`icon${alert.alerttype}Alert`]
                }
              />
            </Grid>
          </Grid>
          <Grid item className={classes.titleWidth}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              className={classes.fullWidth}
            >
              <Grid item container direction="column" xs>
                <Badge
                  variant="dot"
                  invisible={alert.acknowledgements?.length === 0}
                  className={classes.badgeStyle}
                >
                  <Grid item className={classes.fullWidth}>
                    <Typography
                      noWrap
                      variant="body1"
                      className={classes.title}
                    >
                      {/* title of the alert */}
                      {alert.title}
                    </Typography>
                  </Grid>
                </Badge>
                <Grid item className={classes.fullWidth}>
                  <Typography
                    noWrap
                    variant="caption"
                    className={classes.title}
                  >
                    {/* date of the alert */}
                    {date.toLocaleDateString('en-US', longOptions)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ButtonBase>
      <NotificationAlertDialog
        open={open}
        alert={alert}
        dialogHandler={setOpen}
        classes={classes}
      />
    </Card>
  )
}

function NotificationAlertDialog({ open, alert, dialogHandler, classes }) {
  const dispatch = useDispatch()
  const firstDate = alert?.startDate?.split('T')[0]
  const [year, month, day] = firstDate?.split('-')
  const longOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const date = new Date(year, month - 1, day)
  const acknowledgedDate = alert?.acknowledgements?.[0]?.acknowledgedDate
  const dateACK = acknowledgedDate ? new Date(acknowledgedDate) : undefined
  const closeDialogAction = () => {
    console.log('close dialog action')
    logDashboardEvent(dispatch, 'alertsDismissEvent', 'AlertItem', alert.dockey)
    dialogHandler(false)
  }
  const acknowledgeDialogAction = () => {
    logDashboardEvent(
      dispatch,
      'alertsAcknowledgeEvent',
      'AlertItem',
      alert.dockey,
    )
    dispatch(acknowledgeAlert(alert))
    dialogHandler(false)
  }
  return (
    <Dialog open={open} onClose={() => dialogHandler(false)}>
      <DialogTitle
        classes={{
          root: alert.severityCode
            ? classes[`dialogTitle${alert.severityCode}Alert`]
            : alert.alerttype === 'EmergencyAlert'
            ? classes.dialogTitleHighAlert
            : classes[`dialogTitle${alert.alerttype}Alert`],
        }}
      >
        <Grid
          container
          direction="row"
          alignItems="baseline"
          justifyContent="space-between"
        >
          <Grid item container direction="column" wrap="nowrap" xs spacing={1}>
            <Grid item>
              <Typography variant="h4" align="center">
                {alert.title}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Box>
          <Typography variant="subtitle1" className={classes.alertText}>
            Posted{' '}
            <span className={classes.createDateSpan}>
              {date.toLocaleDateString('en-US', longOptions)}
            </span>
          </Typography>
          {alert.alerttype !== 'EmergencyAlert' &&
          alert.alerttype !== 'ITAlert' ? (
            <Typography variant="subtitle1" className={classes.alertText}>
              Acknowledged{' '}
              <span className={classes.isAcknowledgedSpan}>
                {alert.acknowledgements?.length <= 0
                  ? 'Not yet Acknowledged'
                  : 'Acknowledged'}
              </span>
            </Typography>
          ) : null}
          {alert.link ? (
            <Typography variant="subtitle1" className={classes.alertText}>
              Link Title{' '}
              <a
                href={alert.link}
                rel="noopener noreferrer"
                target="_blank"
                className={classes.linkTitleSpan}
              >
                {alert.link}
              </a>
            </Typography>
          ) : null}
          {alert.description ? (
            <div
              // eslint-disable-next-line react/no-danger
              className={classes.descriptionStyle}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(alert.description, {
                  ADD_TAGS: DOMPurifyTagOptions,
                  ADD_ATTR: DOMPurifyAttributeOptions,
                }),
              }}
            />
          ) : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" flex={1}>
          <Button
            onClick={closeDialogAction}
            variant="outlined"
            className={classes.alertActionButton}
          >
            Close
          </Button>
          {alert.acknowledgements?.length === 0 ? (
            alert.alerttype !== 'EmergencyAlert' &&
            alert.severityCode !== 'low' && (
              <Button
                onClick={acknowledgeDialogAction}
                className={
                  alert.severityCode
                    ? classes[`dialogTitle${alert.severityCode}Alert`]
                    : alert.alerttype === 'EmergencyAlert'
                    ? classes.dialogTitleHighAlert
                    : classes[`dialogTitle${alert.alerttype}Alert`]
                }
                variant="outlined"
              >
                Acknowledge
              </Button>
            )
          ) : alert.alerttype !== 'EmergencyAlert' &&
            alert.alerttype !== 'ITAlert' ? (
            <Button
              disabled
              className={
                alert.severityCode
                  ? classes[`dialogTitle${alert.severityCode}Alert`]
                  : alert.alerttype === 'EmergencyAlert'
                  ? classes.dialogTitleHighAlert
                  : classes[`dialogTitle${alert.alerttype}Alert`]
              }
              variant="outlined"
            >
              Acknowledged {dateACK?.toLocaleDateString('en-US')}
            </Button>
          ) : null}
        </Box>
      </DialogActions>
    </Dialog>
  )
}
